import {ColumnDefinitions} from "@/components/Roster/Pages/RosterAthletes/Objects/ColumnDefinitions";

export default ColumnDefinitions.fromRaw([
    { field: "firstName", headerName: "First Name" },
    { field: "lastName", headerName: "Last Name" },
    { field: "email", headerName: "Email Address" },
    { field: "phone", headerName: "Phone Number"},
    { field: "title", headerName: "Title"},
])